import { images } from "./images";

export const problemQuestions = [
  "Which exercise variation should you use?",
  "How many sets and reps?",
  "Should the stance change?",
  "What happens when abdominal growth affects the setup?",
  "When is more support useful?",
  "What should you adjust when the planned RPE suddenly feels harder?",
  "How do you keep the training goal while the client’s balance, range or comfort changes?",
];

export const systemPillars = ["Assessment", "First Trimester", "Second Trimester", "Third Trimester", "Exercise Adaptations"];

export const workflowSteps = [
  "Open the week",
  "Review the workout",
  "Check sets + reps + rest + RPE",
  "Choose the appropriate variation",
  "Coach the session",
  "Record the response",
];

export const practicalCards = [
  { question: "Need the training plan for Week 8?", answer: "It’s organized." },
  { question: "Need a more supported squat?", answer: "It’s included." },
  { question: "Need to change a deadlift setup as abdominal size changes?", answer: "You have alternatives." },
  { question: "Need sets, reps, rest and RPE?", answer: "They’re already structured." },
  { question: "Need home or gym options?", answer: "They’re included." },
];

export const differentiators = [
  { title: "120 Complete Prenatal Workouts", text: "Structured training from Week 1 to Week 40." },
  { title: "Sets + Reps + Rest + RPE", text: "Programming information already organized." },
  { title: "5 Professional Volumes", text: "One complete training system." },
  { title: "Practical Exercise Modifications", text: "Adapt stance, range, support, position and exercise variation." },
  { title: "Everything Organized", text: "Workouts, tracking tools and exercise alternatives together." },
  { title: "Less Repetitive Planning", text: "More time coaching." },
];

export const lookInsideSlides = [
  { caption: "Week 1 — Establish the Baseline", image: images.pageWeek },
  { caption: "Week 8 — Progress Without Chasing Fatigue", image: images.pageLibrary },
  { caption: "Week 14 — Second-Trimester Baseline", image: images.pageTrimester },
  { caption: "Week 22 — Abdominal Clearance", image: images.pageAdaptation },
  { caption: "Week 32 — Adapt Range", image: images.pageTrimester },
  { caption: "Week 38 — Adjust the Session to Today", image: images.pageWeek },
  { caption: "Exercise Modification Matrix", image: images.pageMatrix },
  { caption: "Client Progress Tracker", image: images.pageTracker },
];
